import { render } from "./widget-device-table.vue?vue&type=template&id=24031a68&scoped=true&ts=true"
import script from "./widget-device-table.ts?vue&type=script&lang=ts"
export * from "./widget-device-table.ts?vue&type=script&lang=ts"

import "./widget-device-table.scss?vue&type=style&index=0&id=24031a68&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24031a68"]])

export default __exports__